import { Row, Col, Image } from "antd";

export const StThomasCollege = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="st-thomas-college">
          St. Thomas' College - 600 Million Donation
        </h1>
      </div>
      <Row>
        <Col xs={24} sm={24} md={24}>
          <p>
            On August 11, 2025, renowned Sri Lankan entrepreneur and
            philanthropist Eng. Nahil Wijesuriya made a landmark donation of Rs.
            600 million to S. Thomas’ College, Mount Lavinia, through the Old
            Trinitians Sports Club. The contribution, made via the Agnes
            Wijesuriya Foundation for Children and Elders, will fund the
            development of a state-of-the-art IT complex, equipping the next
            generation of Thomians with advanced technological resources and a
            modern learning environment.
          </p>
          <p>
            This act of generosity reflects Nahil’s enduring belief that
            education and technology are the twin pillars of national progress.
            It also underscores his lifelong gratitude to the institutions that
            shaped his early years and values. As with all his philanthropic
            efforts, the S. Thomas’ College IT Complex project exemplifies
            Nahil’s conviction that true leadership lies not merely in
            enterprise, but in uplifting society through lasting, visionary
            impact.
          </p>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/72-St-Thomas's-College/Newswire+1.jpg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>News Wire</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/72-St-Thomas's-College/Newswire+1.jpg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>News Wire</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "50%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/72-St-Thomas's-College/Newswire+2.jpg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "50%" }}>
              <p>
                <small>News Wire</small>
              </p>
            </div>
          </div>
        </Col>
        <p>ADD CMC ALBUM</p>
      </Row>
    </div>
  );
};
